import { useEffect, useState } from 'react';
import { lightningAPI } from '../api';
import { windfarmTimeZone } from '../prettyDate';

// The windfarm's time zone, looked up from its turbines' positions: `undefined` while they are
// loading, null when none has a position (times are then shown in UTC).
// For pages that show times before they have loaded the turbines for anything else.
export function useWindfarmTimeZone(windfarm_id) {
    const [timeZone, setTimeZone] = useState(undefined);

    useEffect(() => {
        if (!windfarm_id) return;

        let cancelled = false;
        setTimeZone(undefined);
        lightningAPI
            .listTurbinesByWindfarmId(windfarm_id)
            .then((rows) => {
                if (!cancelled) setTimeZone(windfarmTimeZone(rows || []));
            })
            .catch((error) => {
                console.error('Error fetching turbines for the windfarm time zone', error);
                if (!cancelled) setTimeZone(null);
            });

        return () => { cancelled = true; };
    }, [windfarm_id]);

    return timeZone;
}
